<template>
  <el-popover
    v-bind="$attrs"
    v-on="$listeners"
    :ref="`${_uid}-popover`"
    v-on:show="popoverShow(`${_uid}-popover`)"
    v-on:hide="popoverHide(`${_uid}-popover`)"
  >
    <h3 class="popover-title">{{this.title}}</h3>

    <div class="actions-list">
      <div class="elsa-input">
        <el-input
          class="search-users"
          prefix-icon="el-icon-search"
          :placeholder="$t('common.search')"
          v-model.lazy="queryString"
        />
      </div>

        <div class="item-list popover-body">
            <el-checkbox-group
                class="elsa-checkbox-group"
                v-model="popover.selectedClasses"
                >
                <label class="elsa-checkbox group-checkbox-label">{{$t($i18nLabelsHelper(currentOrganizationType, 'class_has_not_teacher'))}}</label>
                <el-checkbox
                    v-for="({name, id}, idx) in classHaveNotOwner"
                    :key="`${_uid}-${idx}-${id}`"
                    class="elsa-checkbox"
                    :label="id"
                >
                    {{name}}
                </el-checkbox>
                <label class="elsa-checkbox group-checkbox-label">{{$t($i18nLabelsHelper(currentOrganizationType, 'class_has_teacher'))}}</label>
                <el-checkbox
                    v-for="({name, id}, idx) in classHaveOwner"
                    :key="`${_uid}-${idx}-${id}`"
                    class="elsa-checkbox"
                    :label="id"
                >
                    {{name}}
                </el-checkbox>
            </el-checkbox-group>
            <div class="pagination">
                <pagination
                  :page-size="maxNumberOfElements"
                  :total="pagination.total"
                  :pager-counter="5"
                  :current-page.sync="currentPage"
                  v-on:current-change="updateCurrentPage"
                />
              </div>
        </div>

        <div class="more-options">
            <primary-button
                :disabled="popover.selectedClasses.length === 0"
                @click.native="handelAssignTeacherToClasses"
            >
                {{$t('common.save')}}
            </primary-button>
            <tertiary-button
                @click.native="$refs[`${_uid}-popover`].$parent.$parent.$el.click()"
            >
                {{$t('common.cancel')}}
            </tertiary-button>
        </div>
    </div>

  <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
  import { either, isEmpty, isNil, filter, compose, prop, startsWith, toLower, propOr, propEq, find, not } from 'ramda'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import Pagination from '@/components/common/Pagination'
  import {
    mapGetters, mapActions,
  } from 'vuex'
  import { successMessage, warningMessage } from '../../utils/messages'
  import { NUMBER_ELEMENTS_PER_PAGE, PAGE_COUNTER } from "@/constants/generic"

  export default {
    components: {
        PrimaryButton,
        TertiaryButton,
        Pagination
    },
    data() {
      return {
        popover: {
          selectedClasses:[]
        },
        queryString: "",
        currentPage: 1,
      }
    },
    props: {
      displayData: {
        type: Array,
        default: () => []
      },
      title: {
        type: String,
      },
      user: {},
      parentRow: {},
      isRowElement: {
        type: Boolean,
        default: false,
      },
      currentOrganizationType: {}
    },
    methods: {
      popoverHide(ref){
        if(this.isRowElement) {
          this.$refs[ref].$el.classList.remove('active-svg')
          this.$el.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove('active')
        }
      },
      popoverShow(ref){
        if(this.isRowElement) {
          this.$refs[ref].$el.classList.add('active-svg')
          this.$el.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add('active')
        }
      },
      handelAssignTeacherToClasses() {
        const selectedClasses = this.popover.selectedClasses;
        const email = this.user.email;
        const assignTeacherRequest = []
        selectedClasses.forEach(groupId => {
            let groupName = compose(propOr('', 'name'), find(propEq('id', groupId)))(this.parsedData)
            assignTeacherRequest.push(this.assignTeacherToClass({groupId, groupName, email}))
        });
        return Promise.all(assignTeacherRequest).then(() =>{
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, 'assign_teacher_to_group_success')
          successMessage(this.$t(message))(this);
          this.popover.selectedClasses = [];
          return this.$refs[`${this._uid}-popover`].$parent.$parent.$el.click()
        })
        .catch(() => {
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, 'assign_teacher_to_group_warning')
          warningMessage(this.$t(message))(this)
          return this.$refs[`${this._uid}-popover`].$parent.$parent.$el.click()
        })
      },
      updateCurrentPage(page) {
        this.currentPage = page;
        this.getClasses({ page })
      },
      ...mapActions('classes', [
        'assignTeacherToClass',
        'getClasses'
      ])
    },
    computed: {
      parsedData() {
        if(either(isEmpty, isNil)(this.queryString)) {
          return this.displayData;
        }
        const lowerQueryString = toLower(this.queryString)

        return filter(
          compose(
            startsWith(lowerQueryString),
            toLower,
            prop("name")
          ),
        )(this.classes)
      },
      classHaveNotOwner(){
          return filter(
              propEq('owner', null)
          )(this.parsedData)
      },
      classHaveOwner(){
          return filter(
              compose(not, propEq('owner', null))
          )(this.parsedData)
      },
      pageCounter() {
        return PAGE_COUNTER
      },
      maxNumberOfElements () {
        return NUMBER_ELEMENTS_PER_PAGE
      },
      ...mapGetters({
        classes: 'classes/getClassList',
        pagination: 'classes/buildPagination',
      }),
    },
  }
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";

.item .el-popover__reference span {
  margin: 0;
}
.el-popover.el-popper {
    .popover-title {
      font-weight: 500;
      font-size: 14px;
      color: $darker-blue;
    }
  .actions-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .item-list, .more-options {
      display: flex;
      flex-direction: column;
    }

    .elsa-input::v-deep {
      width: 100%;

      div.search-users .el-input__inner {
        padding-left: 16px;
      }
    }

    .item-list::v-deep {
      margin-top: 12px;
      padding-bottom: 16px;
      border-bottom: 1px solid $purple;
      max-height: 200px;
      overflow: scroll;
      width: 100%;
      span {
        font-weight: 300;
        color: #6D7A8C;
        padding-bottom: 0px !important;
      }
      .group-checkbox-label {
        padding-bottom: 0px;
      }
    }
    
    .more-options {
      padding-top: 24px;
      display: flex;
      flex-direction: row;

      ::v-deep .elsa-button {
        min-height: 24px;
        min-width: 64px;
        padding: 0px;
        margin: 0;

        &:first-of-type {
          margin-right: 16px;
        }

        span {
          padding: 0;
          margin: 12px auto;
          font-size: 12px;
          text-transform: capitalize;
        }
      }
    }
  }
}
</style>
